'use strict';

/**
 * buildMagicLinkUrl(playerUri, token) — pure builder for the "Magic link"
 * URL shown on the app instance edit screen (#827, epic #684).
 *
 * URL shape: `${playerUri}/#/magic/${token}`, tolerant of a trailing slash
 * (or several) on playerUri so envService-sourced values don't produce a
 * double slash. Returns null when either input is missing, matching the
 * "absent input → inert result" idiom used by shouldFetchDynamic.js.
 *
 * @param {string|null|undefined} playerUri - e.g. envService.read('PLAYER_URI')
 * @param {string|null|undefined} token - the magic link token
 * @returns {string|null}
 */
function buildMagicLinkUrl(playerUri, token) {
    if (!playerUri || !token) return null;

    const normalizedPlayerUri = playerUri.replace(/\/+$/, '');
    return `${normalizedPlayerUri}/#/magic/${token}`;
}

// CommonJS export for Mocha unit tests (guarded so it is a no-op inside the
// concatenated Angular bundle, where `buildMagicLinkUrl` is a plain global —
// mirrors the should-fetch-dynamic.js pattern from #561/#634).
if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
    module.exports = { buildMagicLinkUrl };
}
